import { TextWithCopy } from "@shared/src/components/common/misc/TextWithCopy";
import { TextWithIndicator } from "@shared/src/components/common/misc/TextWithIndicator";
import { OrderResponse } from "@sdk/shared/types/order.types";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { useMemo } from "react";

export interface PaymentMethodSectionProps {
  paymentMethod: { name: string; color: string };
  transactionId: string;
}

export function PaymentMethodSection({ paymentMethod, transactionId }: PaymentMethodSectionProps) {
  console.trace("paymentMethod", paymentMethod, transactionId);
  return (
    <div className="border-2 border-border-secondary rounded-3xl p-4 sm:p-6">
      <div className="flex items-center justify-between gap-4 sm:gap-0">
        <div className="space-y-1">
          <p className="text-text-secondary mb-1 text-small">Payment Method</p>
          <TextWithIndicator
            text={paymentMethod?.name}
            indicatorColor={`#${paymentMethod?.color}`}
            indicatorClassName="h-4 w-0.5"
            className="truncate text-small-2"
          />
        </div>
        <div className="space-y-1">
          <p className="text-text-secondary mb-1 text-small">Transaction ID</p>
          <TextWithCopy text={transactionId} className="text-small font-medium" />
        </div>
      </div>
    </div>
  );
}
